function extractVideoId(url) {
  if (!url) return ''
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/)
  return match ? match[1] : ''
}

export default function VideoBlock({ settings }) {
  const { padding, margin, backgroundColor, borderWidth, borderColor, borderRadius, textAlign, width } = settings
  const videoUrl = settings.videoUrl || ''
  const videoId = extractVideoId(videoUrl)

  const containerStyle = {
    padding: `${padding.top} ${padding.right} ${padding.bottom} ${padding.left}`,
    margin: `${margin.top} ${margin.right} ${margin.bottom} ${margin.left}`,
    backgroundColor: backgroundColor || 'transparent',
    textAlign: textAlign || 'center'
  }

  const thumbnailUrl = settings.thumbnailUrl || (videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : '')

  const imageStyle = {
    display: 'block',
    width: width || '100%',
    maxWidth: '100%',
    height: 'auto',
    margin: textAlign === 'center' ? '0 auto' : '0',
    border: (borderWidth && borderWidth !== '0px') ? `${borderWidth} solid ${borderColor || '#cccccc'}` : 'none',
    borderRadius: borderRadius || '0px'
  }

  if (!videoUrl) {
    return (
      <div style={containerStyle}>
        <div style={{
          width: width || '100%',
          maxWidth: '100%',
          height: '200px',
          backgroundColor: '#1a1a2e',
          borderRadius: borderRadius || '0px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.75rem',
          margin: textAlign === 'center' ? '0 auto' : '0',
          color: '#94a3b8'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <span style={{ color: '#fff', fontSize: '20px', marginLeft: '3px' }}>▶</span>
          </div>
          <span style={{ fontSize: '0.85rem' }}>Add a video URL in settings</span>
        </div>
      </div>
    )
  }

  return (
    <div style={containerStyle}>
      <div style={{ position: 'relative', display: 'inline-block', width: width || '100%', maxWidth: '100%' }}>
        {thumbnailUrl ? (
          <img src={thumbnailUrl} alt={settings.altText || 'Video thumbnail'} style={imageStyle} />
        ) : (
          <div style={{
            ...imageStyle,
            height: '200px',
            backgroundColor: '#1a1a2e',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>Video thumbnail</span>
          </div>
        )}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 0, 0, 0.85)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
        }}>
          <span style={{ color: '#fff', fontSize: '24px', marginLeft: '4px' }}>▶</span>
        </div>
      </div>
    </div>
  )
}
